'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var generateSlug = function generateSlug(title) {
  return title ? title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-').replace(/(-){2,}/g, '-') : 'undefined';
};

exports.default = generateSlug;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/generateSlug.js
// module id = 169
// module chunks = 11